module.exports = __webpack_public_path__ + "static/img/7.ab2d847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/7.jpg
// module id = 6GIE
// module chunks = 1